<template>
    <div>
        <h2>{{ step.title }}</h2>

        <InputRadioGroup
            name="how_did_you_hear_about_us"
            :required="isRequired('how_did_you_hear_about_us')"
            :error="form.errors.get('how_did_you_hear_about_us')"
            v-model="form.how_did_you_hear_about_us"
            :form="form"
            @textarea-updated="form[$event.field] = $event.value"
            :options="getField('how_did_you_hear_about_us').options"
            @input="form.errors.clear('how_did_you_hear_about_us')"
        >
            <template v-slot:question>
                {{ getField("how_did_you_hear_about_us").question }}
            </template>
        </InputRadioGroup>
    </div>
</template>

<script>
import InputRadioGroup from "../Form/InputRadioGroup";
import Form from "../../Form";
import { isRequired } from "./formHelper.js";

export default {
    name: "StepHowDidYouHearAboutUs",
    components: {
        InputRadioGroup,
    },
    methods: {
        getField(fieldName) {
            return this.fields[fieldName];
        },
        isRequired(fieldName) {
            var fieldData = this.getField(fieldName);
            return isRequired(fieldData, this.form);
        },
    },
    data: function () {
        return {
            form: new Form({
                how_did_you_hear_about_us: null,
                heard_other_text: null,
            }, this.formData),
        };
    },
    props: {
        step: Object,
        fields: Object,
        formData: Object,
    },
};
</script>